"use client";

import React, { useState, useLayoutEffect, useRef } from 'react';
import styles from './ContentDisplayTabs.module.css';

const ContentDisplayTabs = ({ tabs, activeTab, setActiveTab }) => {
  const tabContentRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState('auto');

  const renderTabContent = () => {
    const activeTabContent = tabs.find((tab) => (tab.id || tab.label) === activeTab)?.content;
    return activeTabContent || <p>No content available.</p>;
  };

  useLayoutEffect(() => {
    if (!tabContentRef.current) return;

    const measureHeight = () => {
      if (tabContentRef.current) {
        setContainerHeight(tabContentRef.current.getBoundingClientRect().height);
      }
    };

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setContainerHeight(entry.contentRect.height);
      }
    });

    observer.observe(tabContentRef.current);

    const timer = setTimeout(() => {
      measureHeight();
    }, 100);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [activeTab]);

  return (
    <div className={styles.tabs}>
      <div className={styles['tab-links']}>
        {tabs.map((tab) => (
          <button
            key={tab.id || tab.label}
            className={`${styles['tab-link']} ${activeTab === (tab.id || tab.label) ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id || tab.label)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div
        key={activeTab}
        ref={tabContentRef}
        className={styles['tab-content']}
        style={{ minHeight: containerHeight }}
      >
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ContentDisplayTabs;
